import { create } from 'zustand'
import type { ExpenseCategory, Expense } from '@/types'

export interface ExpenseFormData {
  description: string
  amount: string
  date: string
  category: ExpenseCategory
  notes: string
  incurredById: string
}

function todayStr(): string {
  return new Date().toISOString().split('T')[0] ?? ''
}

const EMPTY_FORM: ExpenseFormData = {
  description: '',
  amount: '',
  date: todayStr(),
  category: 'ALTRO',
  notes: '',
  incurredById: '',
}

interface ExpenseDraft {
  showForm: boolean
  editing: Expense | null
  formData: ExpenseFormData
}

interface ExpenseDraftState {
  /** Bozze indicizzate per projectId */
  drafts: Record<string, ExpenseDraft>

  getDraft: (projectId: string) => ExpenseDraft
  setShowForm: (projectId: string, show: boolean) => void
  setEditing: (projectId: string, expense: Expense | null) => void
  setFormData: (projectId: string, data: ExpenseFormData) => void
  resetDraft: (projectId: string) => void
}

const emptyDraft = (): ExpenseDraft => ({
  showForm: false,
  editing: null,
  formData: { ...EMPTY_FORM, date: todayStr() },
})

export const useExpenseDraftStore = create<ExpenseDraftState>()((set, get) => ({
  drafts: {},

  getDraft: (projectId) => get().drafts[projectId] ?? emptyDraft(),

  setShowForm: (projectId, show) =>
    set((state) => ({
      drafts: {
        ...state.drafts,
        [projectId]: { ...(state.drafts[projectId] ?? emptyDraft()), showForm: show },
      },
    })),

  setEditing: (projectId, expense) =>
    set((state) => ({
      drafts: {
        ...state.drafts,
        [projectId]: { ...(state.drafts[projectId] ?? emptyDraft()), editing: expense },
      },
    })),

  setFormData: (projectId, data) =>
    set((state) => ({
      drafts: {
        ...state.drafts,
        [projectId]: { ...(state.drafts[projectId] ?? emptyDraft()), formData: data },
      },
    })),

  resetDraft: (projectId) =>
    set((state) => ({
      drafts: { ...state.drafts, [projectId]: emptyDraft() },
    })),
}))
